"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mortgageMonthlyReducer = void 0;
var MortgageMonthlyAction_1 = require("@/pages/mortagage/actions/MortgageMonthlyAction");
var MortgageCommonReducer_1 = require("@/pages/mortagage/reducers/MortgageCommonReducer");
var MortgageMonthlyState_init_1 = require("@/pages/mortagage/states/MortgageMonthlyState.init");
exports.mortgageMonthlyReducer = function (state, action) {
    if (state === void 0) { state = MortgageMonthlyState_init_1.defaultMortgageMonthlyState; }
    switch (action.type) {
        case MortgageMonthlyAction_1.default.ON_PROPERTY_VALUE_CHANGED: {
            var value = action.payload.replace(/[^0-9]+/g, '');
            value = Math.max(state.propertyValueMin, value);
            value = Math.min(state.propertyValueMax, value);
            return __assign(__assign({}, state), { propertyValue: value, loanAmount: Math.ceil(value * (state.loanAmountPercent) / 100) });
        }
        case MortgageMonthlyAction_1.default.ON_LOANAMOUNT_PERCENT_CHANGED: {
            var value = Math.max(state.loanAmountPercentMin, action.payload);
            value = Math.min(state.loanAmountPercentMax, value);
            return __assign(__assign({}, state), { loanAmountPercent: value, loanAmount: Math.ceil(state.propertyValue * value / 100) });
        }
        case MortgageMonthlyAction_1.default.ON_LOANAMOUNT_CHANGED: {
            var value = action.payload.replace(/[^0-9]+/g, '');
            value = Math.max(state.loanAmountPercentMin * state.propertyValue / 100, value);
            value = Math.min(state.loanAmountPercentMax * state.propertyValue / 100, value);
            return __assign(__assign({}, state), { loanAmountPercent: Math.ceil(value / state.propertyValue * 100), loanAmount: value });
        }
        case MortgageMonthlyAction_1.default.ON_TENOR_CHANGED: {
            var value = Math.max(state.tenorMin, action.payload);
            value = Math.min(state.tenorMax, value);
            return __assign(__assign({}, state), { tenor: value });
        }
        case MortgageMonthlyAction_1.default.ON_INTEREST_RATE_CHANGED: {
            var value = Math.max(state.interestRateMin, action.payload);
            value = Math.min(state.interestRateMax, value);
            return __assign(__assign({}, state), { interestRate: value });
        }
        case MortgageMonthlyAction_1.default.ON_NON_CORPORATE_CHANGED: {
            return __assign(__assign({}, state), { nonCorporate: action.payload });
        }
        case MortgageMonthlyAction_1.default.ON_NON_FIRST_TIME_CHANGED: {
            return __assign(__assign({}, state), { nonFirstTime: action.payload });
        }
        case MortgageMonthlyAction_1.default.ON_HAS_OUTSTANDING_MORTGAGE_CHANGED: {
            return __assign(__assign({}, state), { hasOutstandingMortgage: action.payload });
        }
        case MortgageMonthlyAction_1.default.ON_HAS_TRANSACTION_RECENTLY_CHANGED: {
            return __assign(__assign({}, state), { hasTransactedRecently: action.payload });
        }
        case MortgageMonthlyAction_1.default.ON_HAS_TRANSACTION_RECENTLY_MONTH_CHANGED: {
            return __assign(__assign({}, state), { hasTransactedRecentlyMonth: action.payload });
        }
        case MortgageMonthlyAction_1.default.SET_RESULT: {
            return __assign(__assign({}, state), { result: action.payload });
        }
    }
    return MortgageCommonReducer_1.mortgageCommonReducer(state, action);
};
